
    <div :class="['sweet-modal-tab', { active }]">
		<slot></slot>
	</div>
